import { numberSpacing } from "#root/lib/formatting";
import { prepareCanvas } from "../lib/canvas";
import Chart from 'chart.js/auto';
import { toFont } from 'chart.js/helpers';
import { SankeyController, Flow } from '#root/lib/chartjs-chart-sankey';
Chart.register(SankeyController, Flow); // example https://codepen.io/kurkle/pen/bGVKPOM

/*
{
    "minValue": 0,
    "maxValue": 100,
    "nodes": [
        [
            {
                "label": "Значення 1",
                "id": "val1",
                "color": "#00FF00"
            }
        ],
        [
            {
                "label": "Значення 2",
                "id": "val2",
                "color": "#00FF00"
            },
            {
                "label": "Значення 3",
                "id": "val3",
                "color": "#00FF00"
            }
        ],
        [
            {
                "label": "Значення 4",
                "id": "val4",
                "color": "#00FF00"
            },
            {
                "label": "Значення 5",
                "id": "val5",
                "color": "#00FF00"
            }
        ]
    ],
    "links": [
        [
            {
                "from": "val1",
                "to": "val2",
                "value": 10
            },
            {
                "from": "val1",
                "to": "val3",
                "value": 90
            }
        ],
        [
            {
                "from": "val2",
                "to": "val4",
                "value": 50
            },
            {
                "from": "val2",
                "to": "val5",
                "value": 25
            },
            {
                "from": "val3",
                "to": "val4",
                "value": 75
            }
        ]
    ]
}
*/

export async function flowChart(canvas, {
  nodes,
  links,
  height
}, {
  viewport,
  orientation = "horizontal"
}) {
  const {
    ctx: ctx
  } = prepareCanvas(canvas);
  canvas.height = height ?? Math.max(...nodes.reduce((acc, el) => {
    acc[el.column] = (acc[el.column] || 0) + 1;
    return acc;
  }, [])) * 100 + 60 * 2;
  /*var colors = {
      Oil: "black",
      Coal: "gray",
      "Fossil Fuels": "slategray",
      Electricity: "blue",
      Energy: "orange"
  };*/
  // the y-order of nodes, smaller = higher

  /*var priority = {
      Oil: 1,
      'Narural Gas': 2,
      Coal: 3,
      'Fossil Fuels': 1,
      Electricity: 2,
      Energy: 1
  };*/

  function byId(name) {
    return nodes.find(n => n.id === name);
  }

  const labels = {};
  const column = {};

  for (let node of nodes) {
    let wrappedLabel = node.label;
    wrappedLabel = wrappedLabel.replace(/ \(/g, "\n(");
    labels[node.id] = wrappedLabel + "\n" + numberSpacing(node.value);

    if ("column" in node) {
      column[node.id] = node.column;
      continue;
    }
  }

  const setLinks = [];

  for (let link of links) {
    setLinks.push({
      from: link.from,
      to: link.to,
      flow: "flow" in link ? link.flow : byId(link.from).value
    });
  }
  /* const priority = {};
   const nodesSorted = nodes.sort((a, b) => a.value - b.value);
   for (let i = 0; i < nodesSorted.length; i++) {
      priority[nodesSorted[i].id] = i + 1;
  } */


  const chart = new Chart(ctx, {
    type: "sankey",
    data: {
      datasets: [{
        data: setLinks,
        //priority,
        column,
        labels,
        colorFrom: c => byId(c.dataset.data[c.dataIndex].from).color,
        colorTo: c => byId(c.dataset.data[c.dataIndex].to).color,
        borderWidth: 0,
        color: "white",
        font: {
          family: "e-Ukraine",
          size: 10
        },
        nodeWidth: 16
      }]
    },
    options: {
      plugins: {
        tooltip: {
          callbacks: {
            label(context) {
              const item = context.dataset.data[context.dataIndex];
              return byId(item.from).label + ' › ' + byId(item.to).label + ': ' + numberSpacing(byId(item.to).value);
            }

          } // enabled: false,
          // external: function(context) {
          //     // Tooltip Element
          //     let tooltipEl = document.getElementById('chartjs-tooltip');
          //     // Create element on first render
          //     if (!tooltipEl) {
          //         tooltipEl = document.createElement('div');
          //         tooltipEl.id = 'chartjs-tooltip';
          //         tooltipEl.innerHTML = '<table></table>';
          //         document.body.appendChild(tooltipEl);
          //     }
          //     // Hide if no tooltip
          //     const tooltipModel = context.tooltip;
          //     if (tooltipModel.opacity === 0) {
          //         tooltipEl.style.opacity = 0;
          //         return;
          //     }
          //     // Set caret Position
          //     tooltipEl.classList.remove('above', 'below', 'no-transform');
          //     if (tooltipModel.yAlign) {
          //         tooltipEl.classList.add(tooltipModel.yAlign);
          //     } else {
          //         tooltipEl.classList.add('no-transform');
          //     }
          //     function getBody(bodyItem) {
          //         return bodyItem.lines;
          //     }
          //     // Set Text
          //     if (tooltipModel.body) {
          //         const titleLines = tooltipModel.title || [];
          //         const bodyLines = tooltipModel.body.map(getBody);
          //         let innerHtml = '<thead>';
          //         titleLines.forEach(function(title) {
          //             innerHtml += '<tr><th>' + title + '</th></tr>';
          //         });
          //         innerHtml += '</thead><tbody>';
          //         bodyLines.forEach(function(body, i) {
          //             const colors = tooltipModel.labelColors[i];
          //             let style = 'background:' + colors.backgroundColor;
          //             style += '; border-color:' + colors.borderColor;
          //             style += '; border-width: 2px';
          //             const span = '<span style="' + style + '">' + body + '</span>';
          //             innerHtml += '<tr><td>' + span + '</td></tr>';
          //         });
          //         innerHtml += '</tbody>';
          //         let tableRoot = tooltipEl.querySelector('table');
          //         tableRoot.innerHTML = innerHtml;
          //     }
          //     const position = context.chart.canvas.getBoundingClientRect();
          //     const bodyFont = toFont(tooltipModel.options.bodyFont);
          //     // Display, position, and set styles for font
          //     tooltipEl.style.opacity = 1;
          //     tooltipEl.style.position = 'absolute';
          //     tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
          //     tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
          //     tooltipEl.style.font = bodyFont.string;
          //     tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
          //     tooltipEl.style.pointerEvents = 'none';
          // },

        },
        legend: {
          display: false
        }
      },
      layout: {
        padding: {
          top: 15,
          left: 15,
          right: 15,
          bottom: 60
        }
      }
    }
  });
}